<template>
  <div class="contact-form" :class="$mq">
    <h3 class="mb-0">Contactez nos spécialistes</h3>
    <p class="mb-0">
      Nous avons hâte d'en savoir plus sur votre projet ! Notre équipe de
      spécialistes répondra rapidement à votre message.
    </p>

    <div class="form row mt-5 mx-lg-0 mx-2">
      <div class="col-12 col-lg-3 text-center form-title-container">
        <div class="d-flex h-100">
          <div class="justify-content-center align-self-center w-100">
            <h4 class="mb-0 w-100 py-md-0 py-2">Renseignements</h4>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-9 py-lg-5 px-lg-5 py-3 px-3">
        <transition name="fade" mode="out-in">
          <form ref="formContainer" v-if="submitStatus !== 'OK'">
            <p>
              Veuillez remplir chaque champ de texte avant de cliquer sur
              "Envoyer".
            </p>
            <div class="form-row">
              <div class="form-group col-md-6">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Prénom *"
                  v-model="$v.message.prenom.$model"
                  required
                />
                <transition name="fade" mode="out-in">
                  <small
                    class="form-text text-danger"
                    v-if="$v.message.prenom.$error"
                    >Ce champ est requis.</small
                  >
                </transition>
              </div>
              <div class="form-group col-md-6">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nom *"
                  v-model="$v.message.nom.$model"
                  required
                />
                <transition name="fade" mode="out-in">
                  <small
                    class="form-text text-danger"
                    v-if="$v.message.nom.$error"
                    >Ce champ est requis.</small
                  >
                </transition>
              </div>
            </div>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Société"
                v-model="$v.message.company.$model"
              />
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <input
                  type="email"
                  class="form-control"
                  placeholder="Adresse e-mail *"
                  v-model="$v.message.mail.$model"
                  required
                />
                <transition name="fade" mode="out-in">
                  <small
                    class="form-text text-danger"
                    v-if="$v.message.mail.$error"
                    >Ce champ est requis.</small
                  >
                </transition>
              </div>
              <div class="form-group col-md-6">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Téléphone"
                  v-model="$v.message.phone.$model"
                />
              </div>
            </div>
            <div class="form-group">
              <textarea
                class="form-control"
                rows="5"
                placeholder="Message *"
                v-model="$v.message.message.$model"
                required
              ></textarea>
              <transition name="fade" mode="out-in">
                <small
                  class="form-text text-danger"
                  v-if="$v.message.message.$error"
                  >Ce champ est requis.</small
                >
              </transition>
            </div>
            <div class="text-right">
              <button
                class="cta-link btn btn-primary"
                @click.prevent="send"
                :disabled="submitStatus === 'PENDING'"
              >
                Envoyer
              </button>
            </div>
          </form>

          <p class="mb-0 text-center" v-else>
            Votre message a été envoyé à notre équipe avec succès !
          </p>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "ContactForm",

  data() {
    return {
      message: {
        prenom: null,
        nom: null,
        company: null,
        mail: null,
        phone: null,
        message: null,
      },
      submitStatus: null,
    };
  },

  validations: {
    message: {
      prenom: { required },
      nom: { required },
      company: {},
      mail: { required, email },
      phone: {},
      message: { required },
    },
  },

  methods: {
    send() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";

        let loader = this.$loading.show({
          container: this.$refs.formContainer,
          color: "#d3031c",
          loader: "dots",
        });

        window.emailjs
          .send("smtp_blanchard", "template_asukwg2", this.message)
          .then(() => {
            this.resetData();
            this.submitStatus = "OK";
            loader.hide();
          })
          .catch((e) => {
            this.resetData();
            this.submitStatus = "ERROR";
            loader.hide();
          });
      }
    },

    resetData() {
      this.message = {
        prenom: null,
        nom: null,
        company: null,
        mail: null,
        phone: null,
        message: null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-form {
  margin: 50px 0;

  .form {
    & > div {
      border: 1px solid $primary;
    }

    .btn {
      background-color: $primary;
      border-color: $primary;
      margin-left: auto;
    }

    input:focus,
    textarea:focus {
      border-color: $primary;
      box-shadow: none;
    }

    .form-title-container {
      background-color: $primary;
      color: $white;
      transform: scale(1.05);
    }
  }
}

input,
button,
textarea,
select {
  font: inherit;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s !important;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
